// Lightweight GA4 helper.
// Works with the gtag snippet already in public/index.html.

const sent = new Set();

export function gaTrackEvent(name, params = {}, options = {}) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return; // blocked / not loaded

    const key = options.dedupeKey || name;
    if (sent.has(key)) return;
    sent.add(key);

    window.gtag("event", name, params);
  } catch {
    // never break the app for analytics
  }
}

export function gaResetDedupe(key) {
  try {
    sent.delete(key);
  } catch {
    // ignore
  }
}